/*
 * A helper function that extracts the page's title, description, url, and thumbnail url from the graphql page query.
 * This function doesn't do anything fancy But since it's used on every page, I thought it would be a good idea to just put it into a function that's one line instead of 20.
 */

export default function getPageMetadata(props) {
  // Extract the edges array which has the metadata object in it
  const {
    data: {
      metadata: { edges },
    },
  } = props;

  // If no metadata was found, return default values
  // if (!edges || edges.length === 0) {
  //   console.warn('No metadata found for page');
  //   return {
  //     description: '',
  //     pageTitle: '',
  //     url: '',
  //     thumbnailSrc: null,
  //   };
  // }

  // Extract the description, pageTitle, url, and thumbnail properties from the metadata object
  const { description, pageTitle, url, thumbnail } =
    edges[0].node.frontmatter.pageMetadata;

  // Get the thumbnail's url string
  const thumbnailSrc = thumbnail?.src?.childCloudinaryAsset;

  // Bundle up the extracted properties into one flat object
  return {
    description,
    pageTitle,
    url,
    thumbnailSrc,
  };
}
